import React, { useEffect, useState } from "react";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
// import { useNavigate  } from 'react-router-dom'; // Cambiar a 'react-router-dom'
import { Link, useNavigate, useParams } from "react-router-dom";
import medicGeekApi from "../../config/axiosConfig";
import {
  showConfirmationAlert,
  showErrorAlert,
  showSuccessAlert,
} from "./../../components/alerts";
import "./../../styles/FormPro.css";

const initialFormData = {
  // pcteId: '',
  pcteFechaReg: "",
  pcteNom: "",
  pcteNom2: "",
  pcteApe1: "",
  pcteApe2: "",
  pcteNumDoc: "",
  pcteEd: "",
  pcteSx: "",
  pcteCel: "",
  pcteTel: "",
  pcteDir: "",
  pcteProv: "",
  pcteCiud: "",
  pcteNac: "REPUBLICA DOMINICANA",
  pcteEc: "",
  pcteEmail: "",
  pcteOcup: "",
  seguroId: "",
  seguroNm: "",
  seguroNoAfiliado: "",
  seguroNss: "",
  estatus: "Activo",
  // isEditing: false, // Agregamos la bandera para controlar si estás editando
};

const PacienteForm = ({ onCloseForm, updatePacientesList, pacienteToEdit }) => {
  const [isEditing, setIsEditing] = useState(false); // Establecer isEditing en true si hay un pacienteToEdit
  const [formData, setFormData] = useState(initialFormData);
  const [seguros, setSeguros] = useState([]);
  const { id } = useParams();
  const [pacienteData, setPacienteData] = useState(null); // Agregar la declaración de pacienteData
  const history = useNavigate();
  const { newPcteId } = useParams();
  const [municipios, setMunicipios] = useState([]);
  const [countries, setCountries] = useState([]);
  const [switchStatus, setSwitchStatus] = useState(true); // Nuevo estado para el switch

  useEffect(() => {
    const fetchData = async () => {
      try {
        const patientResponse = await medicGeekApi.get(`/patients/${id}`);
        const patientData = patientResponse ? patientResponse.data : null;

        if (patientData) {
          setPacienteData(patientData);
          setFormData((prevData) => ({
            ...prevData,
            ...patientData,
          }));
          setIsEditing(true);

          // Configura el switch según el estatus del paciente
          if (patientData.estatus === "Activo") {
            setSwitchStatus(true);
          } else {
            setSwitchStatus(false);
          }
        }
      } catch (error) {
        console.error(
          "Error al obtener los datos del paciente o de los países",
          error
        );
      }
    };

    const loadSeguros = async () => {
      try {
        const segurosResponse = await medicGeekApi.get("/seguros");
        const segurosData = segurosResponse.data.filter(
          (seguro) => seguro.estatus === "Activo"
        );
        setSeguros(segurosData);
      } catch (error) {
        console.error("Error al obtener los datos del seguro", error);
      }
    };

    const loadMunicipios = async () => {
      try {
        const municipiosResponse = await medicGeekApi.get("/municipios");
        const municipiosData = municipiosResponse.data;
        setMunicipios(municipiosData);
      } catch (error) {
        console.error("Error al obtener los datos de municipios", error);
      }
    };

    const loadCountries = async () => {
      try {
        const countriesResponse = await medicGeekApi.get("/countries");
        const countriesData = countriesResponse.data;
        setCountries(countriesData);
      } catch (error) {
        console.error("Error al obtener los datos de countries", error);
      }
    };

    const loadData = async () => {
      await fetchData();
      loadSeguros();
      loadMunicipios();
      loadCountries();
    };

    loadData();
  }, [id]);

  const formatBirthDate = (dateStr) => {
    // Formatear la fecha aquí según tu necesidad
    return dateStr;
  };

  const resetForm = () => {
    setFormData(initialFormData);
  };

  const handleInputChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const guardarPaciente = async () => {
    const fechaActual = new Date();
    const dia = fechaActual.getDate();
    const mes = fechaActual.getMonth() + 1;
    const año = fechaActual.getFullYear();
    const ampm = fechaActual.getHours() >= 12 ? "PM" : "AM";
    let horas = fechaActual.getHours() % 12;
    horas = horas === 0 ? 12 : horas;
    const minutos = fechaActual.getMinutes();
    const fechaHoraFormateada = `${mes}/${dia}/${año} ${horas}:${minutos} ${ampm}`;

    try {
      // Validación de fecha de nacimiento
      const birthDate = new Date(formData.pcteEd);
      if (isNaN(birthDate.getTime())) {
        console.error("Fecha de nacimiento inválida:", formData.pcteEd);
        showErrorAlert(
          "La fecha de nacimiento es inválida. Por favor, verifique el formato."
        );
        return;
      }

      const formattedBirthDate = formatBirthDate(formData.pcteEd);

      const createData = {
        ...formData,
        pcteFechaReg: fechaHoraFormateada,
        pcteEd: formattedBirthDate,
      };

      // Usar medicGeekApi para la solicitud POST
      const response = await medicGeekApi.post("/patients", createData);

      if (response.status === 201) {
        showSuccessAlert("El Paciente fue Guardado Correctamente");
        history("/patients");
        resetForm(); // Limpiar el formulario
      } else {
        console.error("Error al guardar el paciente:", response.status);
        showErrorAlert("Hubo un error al guardar el paciente");
      }
    } catch (error) {
      console.error("Error al guardar el paciente:", error);
      showErrorAlert("Hubo un error al guardar el paciente");
    }
  };

  const editarPaciente = async () => {
    try {
      const originalData = pacienteData;
      const updateData = {};

      const excludedProperties = ["showErrorAlert", "otraPropiedad"]; // Agrega aquí cualquier propiedad que deba excluirse

      for (const field in formData) {
        if (
          !excludedProperties.includes(field) &&
          formData[field] !== originalData[field]
        ) {
          updateData[field] = formData[field];
        }
      }

      // Aquí puedes convertir el valor del switch en "Activo" o "Inactivo"
      const estatusTexto = formData.estatus ? "Activo" : "Inactivo";
      if (estatusTexto !== originalData.estatus) {
        updateData.estatus = estatusTexto; // Solo se agrega si hay cambio
      }

      if (Object.keys(updateData).length === 0) {
        onCloseForm();
        return;
      }

      const confirmResult = await showConfirmationAlert(
        "Confirmación",
        "¿Está seguro que desea actualizar el Paciente?"
      );

      if (confirmResult.isConfirmed) {
        // Filtrar las propiedades no deseadas en updateData
        const filteredUpdateData = Object.keys(updateData).reduce(
          (acc, key) => {
            if (!excludedProperties.includes(key)) {
              acc[key] = updateData[key];
            }
            return acc;
          },
          {}
        );

        await medicGeekApi.patch(
          `/patients/${originalData.pcteId}`,
          filteredUpdateData
        );
        showSuccessAlert("El registro fue Actualizado Correctamente");
        history("/patients");
        onCloseForm();
      }
    } catch (error) {
      console.error("Error al editar el paciente:", error);
      console.error("Detalles del error:", error.response); // Agrega esta línea para obtener detalles adicionales
      showErrorAlert("Hubo un error al editar el paciente");
    }
  };

  const handleSubmit = async () => {
    if (isEditing) {
      await editarPaciente();
    } else {
      await guardarPaciente();
    }
  };

  const handleSwitchChange = (e) => {
    const newStatus = e.target.checked;
    setSwitchStatus(newStatus);
    setFormData((prevData) => ({
      ...prevData,
      estatus: newStatus ? "Activo" : "Inactivo",
    }));
  };

  return (
    <div className="pro-container">

      <div className="pro-header">

        <div>
          <h2 className="pro-title">
            {isEditing
              ? "Mantenimiento de Paciente"
              : "Crear Paciente"}
          </h2>
          <p className="pro-subtitle">
            Gestiona la información clínica y personal del paciente
          </p>
        </div>

        <div className="pro-actions">

          {/* EXPEDIENTE */}
          <div className="pro-badge primary p-3">

            <div className="d-flex flex-column">

              <small>Expediente</small>

              <strong>
                Exp-
                {formData.pcteId
                  ?.toString()
                  .padStart(6, "0")}
              </strong>

            </div>

          </div>

          {/* STATUS */}
          <div className="pro-badge success p-3">
            <div className="d-flex align-items-center gap-3">
              <span>
                {switchStatus
                  ? "Activo"
                  : "Inactivo"}
              </span>
              <div className="form-check form-switch m-0">
                <Input
                  className="form-check-input"
                  id="estatus"
                  type="checkbox"
                  checked={switchStatus}
                  onChange={handleSwitchChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================================================= */}
      {/* FORM */}
      {/* ================================================= */}

      <Form>

        {/* ================================================= */}
        {/* INFORMACION PERSONAL */}
        {/* ================================================= */}

        <div className="pro-section-card">
          <div className="pro-section-title">
            <div className="pro-section-icon">
              <i className="bi bi-person-vcard"></i>
            </div>
            <div>
              <h4>
                Información Personal
              </h4>
              <span>
                Datos básicos del paciente
              </span>
            </div>
          </div>
          <div className="row g-4">

            <Col md={6}>
              <FormGroup floating>
                <Input
                  type="text"
                  className="pro-input"
                  id="pcteNom"
                  value={formData.pcteNom}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteNom",
                      e.target.value
                    )
                  }
                  placeholder="Primer Nombre"
                />
                <Label htmlFor="pcteNom">
                  Primer Nombre
                </Label>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup floating>
                <Input
                  type="text"
                  className="pro-input"
                  id="pcteNom2"
                  value={formData.pcteNom2}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteNom2",
                      e.target.value
                    )
                  }
                  placeholder="Segundo Nombre"
                />
                <Label htmlFor="pcteNom2">
                  Segundo Nombre
                </Label>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup floating>
                <Input
                  type="text"
                  className="pro-input"
                  id="pcteApe1"
                  value={formData.pcteApe1}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteApe1",
                      e.target.value
                    )
                  }
                  placeholder="Primer Apellido"
                />
                <Label htmlFor="pcteApe1">
                  Primer Apellido
                </Label>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup floating>
                <Input
                  type="text"
                  className="pro-input"
                  id="pcteApe2"
                  value={formData.pcteApe2}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteApe2",
                      e.target.value
                    )
                  }
                  placeholder="Segundo Apellido"
                />
                <Label htmlFor="pcteApe2">
                  Segundo Apellido
                </Label>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup floating>
                <Input
                  type="text"
                  className="pro-input"
                  id="pcteNumDoc"
                  value={formData.pcteNumDoc}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteNumDoc",
                      e.target.value
                    )
                  }
                  placeholder="Número de Documento"
                />
                <Label htmlFor="pcteNumDoc">
                  Número de Documento
                </Label>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup floating>
                <Input
                  type="date"
                  className="pro-input"
                  id="pcteEd"
                  value={formData.pcteEd}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteEd",
                      e.target.value
                    )
                  }
                />
                <Label htmlFor="pcteEd">
                  Fecha de Nacimiento
                </Label>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup floating>
                <Input
                  className="pro-input"
                  id="pcteSx"
                  value={formData.pcteSx}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteSx",
                      e.target.value
                    )
                  }
                  type="select"
                >
                  <option value="" disabled>
                    Seleccione el Sexo
                  </option>
                  <option value="Masculino">
                    Masculino
                  </option>
                  <option value="Femenino">
                    Femenino
                  </option>
                  <option value="Otro">
                    Indefinido
                  </option>
                </Input>
                <Label htmlFor="pcteSx">
                  Sexo
                </Label>
              </FormGroup>
            </Col>

            <Col md={6}>

              <FormGroup floating>

                <Input
                  className="pro-input"
                  id="pcteEc"
                  value={formData.pcteEc}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteEc",
                      e.target.value
                    )
                  }
                  type="select"
                >

                  <option value="" disabled>
                    Seleccione el Estado Civil
                  </option>

                  <option value="Soltero/a">
                    Soltero/a
                  </option>

                  <option value="Casado/a">
                    Casado/a
                  </option>

                  <option value="Divorciado/a">
                    Divorciado/a
                  </option>

                  <option value="Union Libre">
                    Unión Libre
                  </option>

                  <option value="Viudo/a">
                    Viudo/a
                  </option>

                </Input>

                <Label htmlFor="pcteEc">
                  Estado Civil
                </Label>

              </FormGroup>

            </Col>

          </div>

        </div>

        {/* ================================================= */}
        {/* SEGURO */}
        {/* ================================================= */}

        <div className="pro-section-card">

          <div className="pro-section-title">

            <div className="pro-section-icon green">

              <i className="bi bi-shield-check"></i>

            </div>

            <div>

              <h4>
                Seguro Médico
              </h4>

              <span>
                Información del seguro y afiliación
              </span>

            </div>

          </div>

          <div className="row g-4">

            <Col md={4}>

              <FormGroup floating>

                <Input
                  type="select"
                  className="pro-input"
                  id="seguroNm"
                  value={formData.seguroNm}
                  onChange={(e) =>
                    handleInputChange(
                      "seguroNm",
                      e.target.value
                    )
                  }
                >

                  <option value="" disabled>
                    Selecciona un seguro
                  </option>

                  {seguros.map((seguro) => (

                    <option
                      key={seguro.id}
                      value={seguro.seguroNm}
                    >
                      {seguro.seguroNm}
                    </option>

                  ))}

                </Input>

                <Label htmlFor="seguroNm">
                  ARS
                </Label>

              </FormGroup>

            </Col>

            <Col md={4}>

              <FormGroup floating>

                <Input
                  type="text"
                  className="pro-input"
                  id="seguroNoAfiliado"
                  value={formData.seguroNoAfiliado}
                  onChange={(e) =>
                    handleInputChange(
                      "seguroNoAfiliado",
                      e.target.value
                    )
                  }
                  placeholder="No. Afiliado"
                />

                <Label htmlFor="seguroNoAfiliado">
                  No. Afiliado
                </Label>

              </FormGroup>

            </Col>

            <Col md={4}>

              <FormGroup floating>

                <Input
                  type="text"
                  className="pro-input"
                  id="seguroNss"
                  value={formData.seguroNss}
                  onChange={(e) =>
                    handleInputChange(
                      "seguroNss",
                      e.target.value
                    )
                  }
                  placeholder="NSS"
                />

                <Label htmlFor="seguroNss">
                  NSS
                </Label>

              </FormGroup>

            </Col>

          </div>

        </div>

        {/* ================================================= */}
        {/* CONTACTO */}
        {/* ================================================= */}

        <div className="pro-section-card">

          <div className="pro-section-title">

            <div className="pro-section-icon purple">

              <i className="bi bi-telephone"></i>

            </div>

            <div>

              <h4>
                Información de Contacto
              </h4>

              <span>
                Datos de comunicación y residencia
              </span>

            </div>

          </div>

          <div className="row g-4">

            <Col md={6}>

              <FormGroup floating>

                <Input
                  type="text"
                  className="pro-input"
                  id="pcteCel"
                  value={formData.pcteCel}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteCel",
                      e.target.value
                    )
                  }
                  placeholder="Número Celular"
                />

                <Label htmlFor="pcteCel">
                  Número Celular
                </Label>

              </FormGroup>

            </Col>

            <Col md={6}>

              <FormGroup floating>

                <Input
                  type="text"
                  className="pro-input"
                  id="pcteTel"
                  value={formData.pcteTel}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteTel",
                      e.target.value
                    )
                  }
                  placeholder="Teléfono"
                />

                <Label htmlFor="pcteTel">
                  Teléfono
                </Label>

              </FormGroup>

            </Col>

            {/* PAÍS */}
            <Col md={6}>

              <FormGroup floating>

                <Input
                  className="pro-input"
                  id="pcteNac"
                  value={formData.pcteNac}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteNac",
                      e.target.value
                    )
                  }
                  type="select"
                >

                  {countries.map((country) => (

                    <option
                      key={country.code}
                      value={country.pais}
                    >
                      {country.pais}
                    </option>

                  ))}

                </Input>

                <Label htmlFor="pcteNac">
                  País de Residencia
                </Label>

              </FormGroup>

            </Col>

            {/* DIRECCIÓN */}
            <Col md={6}>

              <FormGroup floating>

                <Input
                  type="text"
                  className="pro-input"
                  id="pcteDir"
                  value={formData.pcteDir}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteDir",
                      e.target.value
                    )
                  }
                  placeholder="Dirección"
                />

                <Label htmlFor="pcteDir">
                  Dirección
                </Label>

              </FormGroup>

            </Col>

            {/* OCUPACIÓN */}
            <Col md={6}>

              <FormGroup floating>

                <Input
                  type="text"
                  className="pro-input"
                  id="pcteOcup"
                  value={formData.pcteOcup}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteOcup",
                      e.target.value
                    )
                  }
                  placeholder="Ocupación"
                />

                <Label htmlFor="pcteOcup">
                  Ocupación
                </Label>

              </FormGroup>

            </Col>

            {/* EMAIL */}
            <Col md={6}>

              <FormGroup floating>

                <Input
                  type="email"
                  className="pro-input"
                  id="pcteEmail"
                  value={formData.pcteEmail}
                  onChange={(e) =>
                    handleInputChange(
                      "pcteEmail",
                      e.target.value
                    )
                  }
                  placeholder="Correo Electrónico"
                />

                <Label htmlFor="pcteEmail">
                  Correo Electrónico
                </Label>

              </FormGroup>

            </Col>

          </div>

        </div>

        {/* ================================================= */}
        {/* ACTIONS */}
        {/* ================================================= */}

        <div className="pro-form-actions">

          <Link to="/patients">

            <Button className="pro-btn-cancel">

              <i className="bi bi-x-circle me-2"></i>

              Cancelar

            </Button>

          </Link>

          <Button
            className="pro-btn-save"
            onClick={
              isEditing
                ? editarPaciente
                : guardarPaciente
            }
          >

            <i className="bi bi-check-circle me-2"></i>

            {isEditing
              ? "Guardar Edición"
              : "Guardar Paciente"}

          </Button>

        </div>

      </Form>

    </div>
  );
};

export default PacienteForm;
